// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, Client, TDataShape } from './client';
import type { DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, DirectoutreachPolicyCreateData, DirectoutreachPolicyCreateResponses, DirectoutreachPolicyAvailableListData, DirectoutreachPolicyAvailableListResponses, DirectoutreachPolicyAvailableRetrieveData, DirectoutreachPolicyAvailableRetrieveResponses, DirectoutreachVotersRetrieveData, DirectoutreachVotersRetrieveResponses, DirectoutreachVotersRetrieveErrors, DirectoutreachVotersHoldingsRetrieveData, DirectoutreachVotersHoldingsRetrieveResponses, DirectoutreachVotersHoldingsRetrieveErrors, DirectoutreachVotersSelectedPolicyRetrieveData, DirectoutreachVotersSelectedPolicyRetrieveResponses, DirectoutreachVotersSelectedPolicyRetrieveErrors, DirectoutreachVotersSelectedPolicyCreateData, DirectoutreachVotersSelectedPolicyCreateResponses, DirectoutreachVotersSelectedPolicyCreateErrors, DirectoutreachVotersCreateCreateData, DirectoutreachVotersCreateCreateResponses, InstitutionalMeetingsearchListData, InstitutionalMeetingsearchListResponses, ProxyvotingPiballotsFilterListData, ProxyvotingPiballotsFilterListResponses, ProxyvotingPimeetingsFilterListData, ProxyvotingPimeetingsFilterListResponses, ProxyvotingSviProposalOverwriteCreateData, ProxyvotingSviProposalOverwriteCreateResponses, ProxyvotingSviProposalOverwriteReasonsListData, ProxyvotingSviProposalOverwriteReasonsListResponses } from './types.gen';
import { directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer, directoutreachPolicyCreateResponseTransformer, directoutreachPolicyAvailableListResponseTransformer, directoutreachPolicyAvailableRetrieveResponseTransformer, directoutreachVotersHoldingsRetrieveResponseTransformer, directoutreachVotersSelectedPolicyRetrieveResponseTransformer, directoutreachVotersSelectedPolicyCreateResponseTransformer, directoutreachVotersCreateCreateResponseTransformer, institutionalMeetingsearchListResponseTransformer, proxyvotingPiballotsFilterListResponseTransformer, proxyvotingPimeetingsFilterListResponseTransformer, proxyvotingSviProposalOverwriteCreateResponseTransformer } from './transformers.gen';
import { client } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Export BetaNXT voter policies snapshot to S3
 * Exports voter policies data to S3 as CSV. Includes holdings for the specified valid_time with policy selections. When multiple holdings exist for the same date, selects the most recent. Synchronous operation with 60s timeout. Requires timezone-aware datetime.
 */
export const directoutreachBetanxtVoterPolicySnapshotExportCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, unknown, ThrowOnError>({
        responseTransformer: directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/directoutreach/betanxt/voter-policy-snapshot:export/',
        ...options
    });
};

/**
 * Create a new voting policy
 * Creates a new voting policy with the provided information.
 */
export const directoutreachPolicyCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachPolicyCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<DirectoutreachPolicyCreateResponses, unknown, ThrowOnError>({
        responseTransformer: directoutreachPolicyCreateResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/directoutreach/policy/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all available voting policies
 * Retrieves a list of all voting available policies.
 */
export const directoutreachPolicyAvailableList = <ThrowOnError extends boolean = false>(options?: Options<DirectoutreachPolicyAvailableListData, ThrowOnError>) => {
    return (options?.client ?? client).get<DirectoutreachPolicyAvailableListResponses, unknown, ThrowOnError>({
        responseTransformer: directoutreachPolicyAvailableListResponseTransformer,
        security: [
            {
                name: 'X-Direct-Outreach-Token',
                type: 'apiKey'
            }
        ],
        url: '/directoutreach/policy/available/',
        ...options
    });
};

/**
 * ViewSet for retrieving available voting policies.
 */
export const directoutreachPolicyAvailableRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachPolicyAvailableRetrieveData, ThrowOnError>) => {
    return (options.client ?? client).get<DirectoutreachPolicyAvailableRetrieveResponses, unknown, ThrowOnError>({
        responseTransformer: directoutreachPolicyAvailableRetrieveResponseTransformer,
        security: [
            {
                name: 'X-Direct-Outreach-Token',
                type: 'apiKey'
            }
        ],
        url: '/directoutreach/policy/available/{id}/',
        ...options
    });
};

/**
 * Get voter's details
 * Retrieves the details for the specified voter, including their ID and broker ID. Use 'mine' as the voter ID to get your own details.
 */
export const directoutreachVotersRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersRetrieveData, ThrowOnError>) => {
    return (options.client ?? client).get<DirectoutreachVotersRetrieveResponses, DirectoutreachVotersRetrieveErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Direct-Outreach-Token',
                type: 'apiKey'
            }
        ],
        url: '/directoutreach/voters/{id}/',
        ...options
    });
};

/**
 * List latest voter's holdings
 * Retrieves the holdings for the specified voter. Use 'mine' as the voter ID to get your own holdings.
 */
export const directoutreachVotersHoldingsRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersHoldingsRetrieveData, ThrowOnError>) => {
    return (options.client ?? client).get<DirectoutreachVotersHoldingsRetrieveResponses, DirectoutreachVotersHoldingsRetrieveErrors, ThrowOnError>({
        responseTransformer: directoutreachVotersHoldingsRetrieveResponseTransformer,
        security: [
            {
                name: 'X-Direct-Outreach-Token',
                type: 'apiKey'
            }
        ],
        url: '/directoutreach/voters/{id}/holdings/',
        ...options
    });
};

/**
 * Get voter's selected policy
 * Retrieves the voting policy selected by the specified voter. Use 'mine' as the voter ID to get your own selected policy.
 */
export const directoutreachVotersSelectedPolicyRetrieve = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersSelectedPolicyRetrieveData, ThrowOnError>) => {
    return (options.client ?? client).get<DirectoutreachVotersSelectedPolicyRetrieveResponses, DirectoutreachVotersSelectedPolicyRetrieveErrors, ThrowOnError>({
        responseTransformer: directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
        security: [
            {
                name: 'X-Direct-Outreach-Token',
                type: 'apiKey'
            }
        ],
        url: '/directoutreach/voters/{id}/selected-policy/',
        ...options
    });
};

/**
 * Update voter's selected policy
 * Updates the voting policy selected by the specified voter. Use 'mine' as the voter ID to set your own selected policy.
 */
export const directoutreachVotersSelectedPolicyCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersSelectedPolicyCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<DirectoutreachVotersSelectedPolicyCreateResponses, DirectoutreachVotersSelectedPolicyCreateErrors, ThrowOnError>({
        responseTransformer: directoutreachVotersSelectedPolicyCreateResponseTransformer,
        security: [
            {
                name: 'X-Direct-Outreach-Token',
                type: 'apiKey'
            }
        ],
        url: '/directoutreach/voters/{id}/selected-policy/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upsert voter with holdings
 * Creates or updates a voter and creates new version of their holdings. Voters are identified by (mediant_id, broker_id). Each request creates new holding records, preserving complete historical data. Queries return only the latest version of each holding.
 *
 *
 */
export const directoutreachVotersCreateCreate = <ThrowOnError extends boolean = false>(options: Options<DirectoutreachVotersCreateCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<DirectoutreachVotersCreateCreateResponses, unknown, ThrowOnError>({
        responseTransformer: directoutreachVotersCreateCreateResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/directoutreach/voters:create/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List meetings with filtering and cursor pagination.
 */
export const institutionalMeetingsearchList = <ThrowOnError extends boolean = false>(options: Options<InstitutionalMeetingsearchListData, ThrowOnError>) => {
    return (options.client ?? client).get<InstitutionalMeetingsearchListResponses, unknown, ThrowOnError>({
        responseTransformer: institutionalMeetingsearchListResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/institutional/meetingsearch',
        ...options
    });
};

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const proxyvotingPiballotsFilterList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingPiballotsFilterListData, ThrowOnError>) => {
    return (options?.client ?? client).get<ProxyvotingPiballotsFilterListResponses, unknown, ThrowOnError>({
        responseTransformer: proxyvotingPiballotsFilterListResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/proxyvoting/piballots/filter',
        ...options
    });
};

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const proxyvotingPimeetingsFilterList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingPimeetingsFilterListData, ThrowOnError>) => {
    return (options?.client ?? client).get<ProxyvotingPimeetingsFilterListResponses, unknown, ThrowOnError>({
        responseTransformer: proxyvotingPimeetingsFilterListResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/proxyvoting/pimeetings/filter',
        ...options
    });
};

/**
 * Create a new Split Vote Instruction Proposal Overwrite.
 */
export const proxyvotingSviProposalOverwriteCreate = <ThrowOnError extends boolean = false>(options: Options<ProxyvotingSviProposalOverwriteCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<ProxyvotingSviProposalOverwriteCreateResponses, unknown, ThrowOnError>({
        responseTransformer: proxyvotingSviProposalOverwriteCreateResponseTransformer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/proxyvoting/svi/proposal/overwrite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve a list of Split Vote Instruction Overwrite Reasons.
 */
export const proxyvotingSviProposalOverwriteReasonsList = <ThrowOnError extends boolean = false>(options?: Options<ProxyvotingSviProposalOverwriteReasonsListData, ThrowOnError>) => {
    return (options?.client ?? client).get<ProxyvotingSviProposalOverwriteReasonsListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/proxyvoting/svi/proposal/overwrite/reasons',
        ...options
    });
};
